import * as React from "react";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { NavBarFinal } from "../components/NavBarFinal";
import { FooterFinal } from '../components/index';
import Paper from "@mui/material/Paper";
import { Skeleton } from "@mui/material";


function TabPanel(props) {
   const { children, value, index, ...other } = props;

   return (
      <div
         role="tabpanel"
         hidden={value !== index}
         id={`simple-tabpanel-${index}`}
         aria-labelledby={`simple-tab-${index}`}
         {...other}
      >
         {value === index && (
            <Box sx={{ p: 4, backgroundColor: "#212529" }}>
               <Typography>{children}</Typography>
            </Box>
         )}
      </div>
   );
}

TabPanel.propTypes = {
   children: PropTypes.node,
   index: PropTypes.number.isRequired,
   value: PropTypes.number.isRequired,
};

export const Agenda = () => {
   document.title = "Florida Venture Summit | Agenda";



   useEffect(() => {
      var bz = document.createElement("script");
      bz.type = "text/javascript";
      bz.async = true;
      bz.src = "https://organizer.bizzabo.com/widgets/agenda/agenda.js";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(bz, s);
   });

   const [isLoading, setIsLoading] = useState(true);

   return (
      <div>
         <NavBarFinal />
         {/* static image with text */}
         {/* <img style={{ width: '100%', height: 'auto' }} src={window.innerWidth < 1000 ? "./assets/media/Agenda Benner Mobile.png" : "./assets/media/Agenda Benner.png"} /> */}

         {window.innerWidth < 1000 ?
            <img alt='agenda-banner' style={{ width: '100%', height: 'auto' }} src="./assets/media/Agenda Benner Mobile.png" />
            :

            isLoading ?
               <>
                  <Skeleton variant="rectangular" >
                     <div style={{ position: 'relative', display: 'inline-block' }}>
                        <img alt='agenda' style={{ display: 'block', width: '100%', height: 'auto' }} src="./assets/media/agenda image fvs22.png" />
                     </div>
                  </Skeleton>
                  <img alt='agenda' style={{ display: 'none' }} src="./assets/media/agenda image fvs22.png" onLoad={() => setIsLoading(false)} />
               </> :

               <div style={{ position: 'relative', display: 'inline-block' }}>
                  <img alt='agenda' style={{ display: 'block', width: '100%', height: 'auto' }} src="./assets/media/agenda image fvs22.png" />

                  <div style={{
                     position: "absolute",
                     top: "10%",
                     left: 0,
                     boxSizing: "border-box",
                     width: "90%",
                     padding: "10px",
                     textAlign: "center",
                     marginLeft: "5%",
                     marginRight: "5%",
                  }}>
                     <h1 style={{ textAlign: "left", fontSize: "2.5vw", fontWeight: "999" }}>
                        “Venture Summit is a crossroads of the critical elements of success in the venture ecosystem”
                        <span style={{ fontSize: "1.25vw", fontWeight: "500" }}> &nbsp;&nbsp; -Daniel Burstein, Millennium Technology Value Partners</span>
                     </h1>
                  </div>
                  <div style={{
                     position: "absolute",
                     bottom: "10%",
                     left: 0,
                     boxSizing: "border-box",
                     width: "90%",
                     padding: "10px",
                     textAlign: "center",
                     marginLeft: "5%",
                     marginRight: "5%",
                  }}>
                     <h1 style={{ fontSize: "4vw", fontWeight: "999", color: "white" }}>AGENDA</h1>
                  </div>
               </div>}



         <Paper
            elevation={3}
            sx={{ width: '100% !impotant', m: window.innerWidth < 769 ? 0 : 5, p: window.innerWidth < 769 ? 0 : 5, maxWidth: "1250px", margin: '5% auto' }}>


            <div name="bizzabo-web-agenda" data-unique-name="417587" data-internal-website-base-url="https://widget.youngstartup.com/"></div>
            <a
               rel='noreferrer'
               className="bizzabo-link-class"
               style={{
                  textAlign: "right",
                  paddingRight: "17px",
                  textDecoration: "none",
                  width: "100%",
                  display: "inline-block",
                  marginTop: "5px",
                  boxSizing: "border-box",
               }}
               href="https://www.bizzabo.com?utm_source=tickets_widget&utm_medium=powered_by&utm_campaign=tickets_widget"
               target="_blank"
            >
               Powered by Bizzabo
            </a>
         </Paper>
         <FooterFinal />
      </div >
   );
};
